// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as Styles from "./styles";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as Core from "@material-ui/core";
import * as MaterialUi_Typography from "@jsiebern/bs-material-ui/src/MaterialUi_Typography.bs.js";

var make = Styles.ActionTab;

var ActionTab = {
  make: make
};

var make$1 = Styles.ActionButton;

var ActionButton = {
  make: make$1
};

function Actions$ActionBtn(Props) {
  var action = Props.action;
  var onClick = Props.onClick;
  var children = Props.children;
  return React.createElement(make$1, {
              children: React.createElement(Core.Typography, MaterialUi_Typography.makeProps(undefined, Caml_option.some(children), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)),
              onClick: (function (param) {
                  return Curry._1(onClick, (function (param) {
                                return action;
                              }));
                })
            });
}

var ActionBtn = {
  make: Actions$ActionBtn
};

function Actions(Props) {
  var action = Props.action;
  var setAction = Props.setAction;
  var startButton = React.createElement(Actions$ActionBtn, {
        action: "Doing",
        onClick: setAction,
        children: "Start"
      });
  var pauseButton = React.createElement(Actions$ActionBtn, {
        action: "Pause",
        onClick: setAction,
        children: "Pause"
      });
  var hideButton = React.createElement(Actions$ActionBtn, {
        action: "Hide",
        onClick: setAction,
        children: "Hide Timer"
      });
  var resetButton = React.createElement(Actions$ActionBtn, {
        action: "Reset",
        onClick: setAction,
        children: "Reset"
      });
  if (action === "Doing") {
    return React.createElement(make, {
                children: null
              }, pauseButton, hideButton);
  } else if (action === "Hide" || action === "Done" || action === "Reset") {
    return React.createElement(make, {
                children: resetButton
              });
  } else {
    return React.createElement(make, {
                children: null
              }, startButton, hideButton);
  }
}

var Style;

var make$2 = Actions;

var $$default = Actions;

export {
  ActionTab ,
  ActionButton ,
  Style ,
  ActionBtn ,
  make$2 as make,
  $$default ,
  $$default as default,
  
}
/* make Not a pure module */
